import {
  Injectable,
  Renderer2,
  RendererFactory2,
  inject
} from '@angular/core';

import jackpotRu from '../../../assets/json-ld/ru/jackpot.json';
import jackpotEn from '../../../assets/json-ld/en/jackpot.json';
import wheelRu from '../../../assets/json-ld/ru/wheel.json';
import wheelEn from '../../../assets/json-ld/en/wheel.json';
import crashRu from '../../../assets/json-ld/ru/crash.json';
import crashEn from '../../../assets/json-ld/en/crash.json';
import crazyWheelRu from '../../../assets/json-ld/ru/crazy-wheel.json';
import crazyWheelEn from '../../../assets/json-ld/en/crazy-wheel.json';
import defuseRu from '../../../assets/json-ld/ru/defuse.json';
import defuseEn from '../../../assets/json-ld/en/defuse.json';
import doubleRu from '../../../assets/json-ld/ru/double.json';
import doubleEn from '../../../assets/json-ld/en/double.json';
import minesRu from '../../../assets/json-ld/ru/mines.json';
import minesEn from '../../../assets/json-ld/en/mines.json';

@Injectable({
  providedIn: 'root'
})
export class JsonLdService {
  private readonly renderer: Renderer2 = inject(RendererFactory2).createRenderer(null, null);
  private scriptElement?: HTMLScriptElement;
  private readonly jsonMap: Record<'ru' | 'en', Record<string, object>> = {
    ru: {
      jackpot: jackpotRu,
      wheel: wheelRu,
      crash: crashRu,
      crazyWheel: crazyWheelRu,
      defuse: defuseRu,
      double: doubleRu,
      mines: minesRu
    },
    en: {
      jackpot: jackpotEn,
      wheel: wheelEn,
      crash: crashEn,
      crazyWheel: crazyWheelEn,
      defuse: defuseEn,
      double: doubleEn,
      mines: minesEn
    }
  };

  loadJsonLd(route: string, locale: 'en' | 'ru'): void {
    this.removeJsonLd();
    const jsonLd = this.jsonMap[locale]?.[route];

    if (jsonLd) {
      this.addJsonLd(JSON.stringify(jsonLd));
    }
  }

  private addJsonLd(jsonLd: string): void {
    this.scriptElement = this.renderer.createElement('script') as HTMLScriptElement;
    this.scriptElement.type = 'application/ld+json';
    this.scriptElement.textContent = jsonLd;
    this.renderer.appendChild(document.head, this.scriptElement);
  }

  private removeJsonLd(): void {
    if (this.scriptElement?.parentNode) {
      this.scriptElement.parentNode.removeChild(this.scriptElement);
      this.scriptElement = undefined;
    }
  }
}
